import { type FC, type ReactNode } from "react";
import { type ArrowPosition } from "@root/shared/types/type";
import { Presentation } from "./Presentation";

type Props = {
  children: ReactNode; // ToolTipにはテキストのコンテンツのみ入る想定
  className?: string;
  arrowPosition: ArrowPosition;
  bottom?: string;
  top?: string;
  // 親要素を超えて要素を表示したい場合に指定
  right?: string; // ex) 右に50pxはみ出したい場合 rightに"-50px を指定"
  left?: string;
  zIndex?: string;
  isHovered: boolean;
};

export const ToolTip: FC<Props> = ({
  children,
  className,
  arrowPosition,
  bottom = "auto",
  top = "auto",
  right = "auto",
  left = "auto",
  zIndex = "auto",
  isHovered,
}) => {
  return isHovered ? (
    <Presentation
      className={className}
      arrowPosition={arrowPosition}
      right={right}
      left={left}
      bottom={bottom}
      top={top}
      zIndex={zIndex}
    >
      {children}
    </Presentation>
  ) : null;
};
